import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678970cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[37px] tw-rounded-[6px] tw-gap-[10px]"
}
const _hoisted_2 = { class: "tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]" }
const _hoisted_3 = { class: "tw-mb-[25px] tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-medium" }
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(['tw-flex tw-justify-between tw-items-center'])
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(['tw-text-[#FFFFFF] tw-text-[14px] tw-font-semibold'])
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-bg-[#FFFFFF] tw-rounded-[50%]" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#387DFF] tw-text-base tw-font-medium tw-mt-[2px]" }, "+")
], -1))

import { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import WizardRadioQuestion from "./wizardRadioQuestion.vue";
import { Ref, computed, ref, watch } from "vue";
import store from "@/store";
import ListSite from "./listSite.vue";
import { statusPage } from "@/utils/constants";
import WarningIcon from "../svgs/warningIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'sitesPage',
  props: {
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
},
  emits: [
  "onUpdate",
  "update:answer",
  "changeStatusAddSites",
  "checkValidate",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



watch(props.statusInPage, (value) => {
  if (value.statusPage === statusPage.CallApi) {
    sites.value = sites.value.map((item) => {
      item.isCallAPI = true;
      return item;
    });
  }
});


const listSiteRef: any = ref([]);
const haveSiteValue: Ref<number | null> = ref(null);
const sitesValue: any = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.sites[0]
    ?.values;
});
const sites: Ref<any> = ref(sitesValue);
// const isSiteName = computed(() => {
//   const appName =
//     haveSiteValue.value === null
//       ? store.state.SetupWizard.questions[
//           currentOrg.value.id
//         ]?.sites[0]?.values.some(
//           (item) =>
//             (item.name ||
//               item.typeId ||
//               item.legalTypeId ||
//               item.siteAttributes.length) &&
//             !item.isArchived,
//         )
//       : haveSiteValue.value;
//   return appName ? 1 : "";
// });

const isSiteName = computed(() => {
  const appName = store.state.SetupWizard.questions[
    currentOrg.value.id
  ]?.sites[0]?.values.some(
    (item) =>
      (item.name ||
        item.typeId ||
        item.legalTypeId ||
        item.siteAttributes.length) &&
      !item.isArchived,
  );
  return appName ? 1 : "";
});

const currentOrg = computed(() => store.state.Org.currentOrg);

const checkYesNo = (value) => {
  haveSiteValue.value = value;
  emits("onUpdate", value);
};

const addAnother = () => {
  const objAdd = {
    name: null,
    address1: null,
    address2: null,
    address3: null,
    typeId: null,
    townCity: null,
    postcode: null,
    countryId: null,
    phoneNumber: null,
    details: null,
    notes: null,
    showAccordion: false,
    siteAttributes: [],
    isArchived: false,
    isCollapse: false,
  };
  store.commit("SetupWizard/SET_SITES_PUSH", {
    objAdd,
    currentOrg: currentOrg.value.id,
  });
  emits("checkValidate", true);
};
const updateCollapse = (data) => {
  sites.value[data.index].isCollapse = data.collapse;
};
const showDetails = async () => {
  for (let index = 0; index < listSiteRef.value.length; index++) {
    const test = await listSiteRef.value[index].saveChanges();
    if (!test.isValid) {
      if (!sites.value[index]?.isCollapse) {
        sites.value[index].isCollapse = true;
      }
    }
  }
};
const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  if (!haveSiteValue.value) {
    return isAllValid;
  }
  for (let index = 0; index < listSiteRef.value.length; index++) {
    const item = await listSiteRef.value[index].saveChanges();

    if (!item.isValid) {
      isAllValid = false;
    }
    listServices.push(item.finalValue);
  }
  return isAllValid;
};

__expose({
  checkAllValidations,
  showDetails,
});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WizardQuestion, {
      title: 
        _unref(getComponentUiText)('app-menu-submenu-home-setup-wizard-sites-title-1')
      ,
      description: 
        _unref(getComponentUiText)(
          'app-menu-submenu-home-setup-wizard-sites-description-1',
        )
      
    }, {
      default: _withCtx(() => [
        _createVNode(WizardRadioQuestion, {
          class: _normalizeClass(['tw-mb-[25px]']),
          title: 
          _unref(getComponentUiText)(
            'app-menu-submenu-home-setup-wizard-sites-question-domains-1',
          )
        ,
          answer: isSiteName.value,
          required: true,
          onOnUpdate: checkYesNo
        }, null, 8, ["title", "answer"]),
        (
          __props.statusInPage.statusPage === _unref(statusPage).Error &&
          __props.statusInPage.errorMessage
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(WarningIcon, { color: "#F7553C" }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: __props.statusInPage.errorMessage
                  ? _unref(ensurePeriod)(__props.statusInPage.errorMessage)
                  : "",
              },
            )), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['detail-container', haveSiteValue.value === 1 ? 'show' : ''])
        }, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-sites-note-1",
            )), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sites.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${item.id}-${index}`,
              class: "tw-mb-[10px]"
            }, [
              _createVNode(ListSite, {
                ref_for: true,
                ref_key: "listSiteRef",
                ref: listSiteRef,
                data: { item: item, index: index },
                "status-in-page": __props.statusInPage,
                onUpdateCollapse: updateCollapse
              }, null, 8, ["data", "status-in-page"])
            ]))
          }), 128)),
          _createVNode(_component_b_button, {
            variant: "primary",
            class: "button-add-another tw-bg-[#387DFF] tw-py-[15px] tw-px-[25px] tw-rounded-md tw-w-full",
            onClick: addAnother
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                  "app-menu-submenu-home-setup-wizard-sites-add-another-button-1",
                )), 1),
                _hoisted_7
              ])
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["title", "description"])
  ]))
}
}

})